// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { EnrollmentApplication } from "../../../Utilities";
import { EnrollmentApplicationGuardianFormValues } from "../EnrollmentApplicationGuardian";
import { EnrollmentApplicationStudentFormValues } from "../EnrollmentApplicationStudent";

export type Base = {
	source: EnrollmentApplication["source"];
	sourceDetails: EnrollmentApplication["sourceDetails"];
	doesConsentToCorrespondence: EnrollmentApplication["doesConsentToCorrespondence"];
	doesConsentToDataUse: EnrollmentApplication["doesConsentToDataUse"];
	doesConsentToDataProtectionPolicy: EnrollmentApplication["doesConsentToDataProtectionPolicy"];
	notes: EnrollmentApplication["notes"];
	signatureName: EnrollmentApplication["signatureName"];
	signatureDate: EnrollmentApplication["signatureDate"] | null;
};

export type Create = Base & {
	enrollmentApplicationGuardians: EnrollmentApplicationGuardianFormValues.CreateInEnrollmentApplication[];
	enrollmentApplicationStudents: EnrollmentApplicationStudentFormValues.CreateInEnrollmentApplication[];
};

export type CreateRequiredKey = Extract<keyof Create, never>;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	source: "",
	sourceDetails: "",
	doesConsentToCorrespondence: false,
	doesConsentToDataUse: false,
	doesConsentToDataProtectionPolicy: false,
	notes: "",
	signatureName: "",
	signatureDate: null,
	enrollmentApplicationGuardians: [],
	enrollmentApplicationStudents: [],
};

export type Detail = Base & {
	createdAt: EnrollmentApplication["createdAt"] | null;
	wasInquirySubmitted: EnrollmentApplication["wasInquirySubmitted"];
	inquirySubmittedAt: EnrollmentApplication["inquirySubmittedAt"] | null;
	wasApplicationSubmitted: EnrollmentApplication["wasApplicationSubmitted"];
	applicationSubmittedAt: EnrollmentApplication["applicationSubmittedAt"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;
